import { usePageTransition } from '../context/TransitionContext.jsx';
import '../assets/css/src/callout-card.css';

export default function CalloutCard({ title, subtitle, imageSrc, iframeSrc, cta }) {
  const { navigateTo } = usePageTransition();
  const isInternal = cta?.href && cta.href.startsWith('/');

  function handleCtaClick(e) {
    e.preventDefault();
    document.activeElement?.blur();
    navigateTo(cta.href);
  }

  return (
    <div className="callout-card">
      {title && <h2 className="callout-card-title">{title}</h2>}
      {iframeSrc && (
        <div className="callout-card-media">
          <iframe
            src={iframeSrc}
            title={title}
            width="100%"
            scrolling="no"
            frameBorder="no"
            allow="autoplay"
          />
        </div>
      )}
      {!iframeSrc && imageSrc && (
        <div className="callout-card-media">
          <img src={imageSrc} alt={title ?? ''} />
        </div>
      )}
      <div className="callout-card-body">
        {subtitle && <p className="callout-card-subtitle">{subtitle}</p>}
        {cta?.href && (
          isInternal ? (
            <a className="callout-card-cta" href={cta.href} onClick={handleCtaClick}>
              {cta.label ?? 'Learn more'}
            </a>
          ) : (
            <a className="callout-card-cta" href={cta.href} target="_blank" rel="noreferrer">
              {cta.label ?? 'Learn more'}
            </a>
          )
        )}
      </div>
    </div>
  );
}
